import { Routes } from '@angular/router';

import { MpsIsAdminGuard } from '../mps/guards/mps-isadmin.guard';
import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { applicationRouteNames } from './application-route-names';

export const applicationRoutes: Routes = [
  {
    path: applicationRouteNames.home,
    loadChildren: () => import('./mps-home/mps-home.routes').then((m) => m.mpsHomeRoutes),
    data: { title: 'general.navigation.home', icon: 'nav-home' },
    canActivate: [MpsLoggedInGuard],
    canLoad: [],
  },
  {
    path: applicationRouteNames.notes,
    loadChildren: () => import('./notes/notes.routes').then((m) => m.notesRoutes),
    data: { title: 'general.navigation.notes', icon: 'edit' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.documents,
    loadChildren: () => import('./documents/documents.routes').then((m) => m.documentsRoutes),
    data: { title: 'general.navigation.documents', icon: 'nav-documents' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.articles,
    loadChildren: () => import('./articles/articles.routes').then((m) => m.articlesRoutes),
    data: { title: 'general.navigation.articles_management', icon: 'nav-articles' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.developmentActions,
    loadChildren: () =>
      import('./development-actions/development-actions.routes').then((m) => m.developmentActionsRoutes),
    data: { title: 'general.navigation.development_actions', icon: 'nav-actions' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.individualDevelopmentPlans,
    loadChildren: () =>
      import('./individual-development-plans/individual-development-plans.routes').then(
        (m) => m.individualDevelopmentPlansRoutes
      ),
    data: { title: 'general.navigation.pdi', icon: 'nav-pdi' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.keyCompetencyAssessment,
    loadChildren: () =>
      import('./key-competency-assessment/key-competency-assessment.routes').then(
        (m) => m.keyCompetencyAssessmentRoutes
      ),
    data: { title: 'general.navigation.key_competency_assessment', icon: 'nav-evaluations' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.positions,
    loadChildren: () => import('./positions/positions.routes').then((m) => m.positionsRoutes),
    data: { title: 'general.navigation.positions', icon: 'nav-positions' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.feedbacks,
    loadChildren: () => import('./feedbacks/feedbacks.routes').then((m) => m.feedbacksRoutes),
    data: { title: 'general.navigation.feedbacks', icon: 'nav-feedbacks' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.timeAllocation,
    loadChildren: () => import('./time-allocation/time-allocation.routes').then((m) => m.timeAllocationRoutes),
    data: { title: 'general.navigation.time_allocation', icon: 'nav-time-allocation' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.resources,
    loadChildren: () => import('./resources/resources.routes').then((m) => m.resourcesRoutes),
    data: { title: 'general.navigation.resources', icon: 'nav-documents' },
    canActivate: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.administration,
    data: { title: 'general.navigation.administration', icon: 'nav-admin' },
    canActivate: [MpsIsAdminGuard],
    canLoad: [MpsIsAdminGuard],
    children: [
      {
        path: applicationRouteNames.users,
        loadComponent: () => import('./administration/users/list/list.component').then((m) => m.ListComponent),
        data: { title: 'general.navigation.users' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.articles,
        loadComponent: () => import('./administration/articles/list/articles-admin-list.component'),
        data: { title: 'general.navigation.articles_management' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.lokalise,
        loadComponent: () => import('./administration/lokalise/lokalise.component').then((m) => m.LokaliseComponent),
        data: { title: 'general.navigation.lokalise' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
    ],
  },
];
